.container {
  display: flex;
  flex-direction: column;
  width: 20rem;
  height: 10rem;
  padding-left: 2rem;
  padding-bottom: 1rem;
  padding-right: 1rem;
}

.histogram {
  overflow: visible;
  background-color: var(--h5w-histogram--bgColor, white);
}

.bar {
  fill: var(--h5w-histogram--color, royalblue);
}

.markers {
  color: var(--h5w-histogram-marker--color, midnightblue);
  stroke: currentColor;
  fill: currentColor;
}
